import { GlobalAxios } from "../axios/axios-config";
import { IListImportContact } from "../models/list-import-contacts";

const LIST_IMPORT_CONTACTS_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportContact/";

export const getListImportContactById = (id: string) => {
  return GlobalAxios.get<IListImportContact>(LIST_IMPORT_CONTACTS_ROUTE + id);
};
